export function isDicomTypeUtils(fileName: string): boolean {
    const specialExtensions: string[] = ['.dfx', '.zip', '.dcdt'];
    return specialExtensions.some((ext) => fileName.endsWith(ext) || fileName.includes(ext));
}